(function(){
'use strict';

angular.module('classy').component('dropdownField', {
  template: '\n      <form-label\n      required="$ctrl.required"\n      ng-if="$ctrl.label"\n      _spec="label">\n        {{:: $ctrl.label }}\n      </form-label>\n\n      <dropdown-control\n      ng-model="$ctrl.model"\n      ng-model-options="{ getterSetter: $ctrl.getterSetter }"\n      options="$ctrl.options"\n      sc-validity-reporter\n      sc-validity-classes\n      ng-required="$ctrl.required"\n      name="{{:: $ctrl.name }}"\n      width="$ctrl.width"\n      _spec="input"></dropdown-control>\n\n      <form-error\n      name="$ctrl.name"\n      messages="$ctrl.errorMessages"\n      _spec="errors"></form-error>\n    ',
  bindings: {
    model: '=',
    options: '<',
    name: '<',
    label: '<?',
    errorMessages: '<?',
    getterSetter: '<?',
    required: '<?',
    width: '<?'
  },
  controller: function InputFieldCtrl() {
    var DEFAULTS = {
      errorMessages: {
        required: 'This field is required.'
      },
      getterSetter: false,
      required: false
    };

    this.$onInit = function () {
      _.defaultsDeep(this, DEFAULTS);
    };
  }
});
})();